<div class="login-container">
  <div class="login-brand">
    <div class="brand-decoration"></div>
    <div class="brand-content">
      <span class="brand-eyebrow">Nyzed</span>
      <h1 class="brand-title">Nuova<br /><em>password</em></h1>
      <p class="brand-tagline">
        Scegli una password sicura di almeno 8 caratteri.
      </p>
    </div>
  </div>

  <div class="login-form-side">
    <div class="login-card">

      <ng-container *ngIf="!done; else doneState">
        <h2>Reimposta password</h2>

        <div class="error-msg" *ngIf="error">{{ error }}</div>

        <div class="input-group">
          <input
            class="input-field"
            type="password"
            placeholder="Nuova password (min. 8 caratteri)"
            [(ngModel)]="password"
            autocomplete="new-password"
          />
        </div>
        <div class="input-group">
          <input
            class="input-field"
            type="password"
            placeholder="Conferma password"
            [(ngModel)]="confirm"
            (keyup.enter)="submit()"
            autocomplete="new-password"
          />
        </div>

        <button class="submit-button" (click)="submit()" [disabled]="loading">
          {{ loading ? 'Salvataggio...' : 'Salva nuova password' }}
        </button>
      </ng-container>

      <ng-template #doneState>
        <div class="success-box">
          <span class="success-icon">✦</span>
          <h2>Password aggiornata</h2>
          <p>Verrai reindirizzata al login tra qualche secondo.</p>
        </div>
      </ng-template>

      <p class="register-link" style="margin-top:1.5rem">
        <a routerLink="/login">← Torna al login</a>
      </p>
    </div>
  </div>
</div>
